'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _fluxActions = require('flux-actions');

var _ActionTypes = require('MeetingsLib/redux/actions/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _timezone = require('MeetingsLib/constants/timezone');

var _getTimezoneGroups = require('timezone-utils/utils/getTimezoneGroups');

var _getTimezoneGroups2 = _interopRequireDefault(_getTimezoneGroups);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = 'Europe/Belfast';

exports.default = (0, _fluxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _ActionTypes2.default.SET_TIMEZONE, function (state, action) {
  return action.timezone;
}), _defineProperty(_handleActions, _ActionTypes2.default.PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED, function (state, action) {
  var timezone = action.payload.bookInfo.customParams.timezone;


  if (state === _timezone.INVALID_TZ_GUESS) {
    return (0, _getTimezoneGroups2.default)().resolve(timezone);
  }

  return state;
}), _handleActions), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/redux/reducers/userTimezone.js
// module id = 530
// module chunks = 0